// extracted by mini-css-extract-plugin
export default {"simpleButtonContainer":"SimpleButton_simpleButtonContainer__IQA8N"};